import { createAction, handleActions } from 'redux-actions';

const setFetching = createAction("SCREENS/PROJECT_VIEW/SET_FETCHING");

const defaultState = false

const reducer = handleActions(
  {
    [setFetching]: (state, action) => action.payload
  },
  defaultState
);

export { setFetching, reducer };